export enum SecurityStatus {
  GeoIP = 4,
  TrapQuestionFailure = 22,
  MinLOITerminate = 26,
  PreScreenerTerminate = 28,
  PidTerminate = 30,
  SecurityTerminateExceededPunch = 38,
  PartialComplete = 34,
  NonMobileTerminate = 35,
  MobileTerminate = 36,
  RvidFraudProfile = 43,
  HostQuotaTerminate = 46,
  DemoTerminate = 47,
  OrganizationBlacklisted = 55,
  TabletTerminate = 56,
  DemoTerminateCustom = 64,
  ClientRedirect = 54
}
